import React from 'react'

import { PropertyFacilities } from 'src/types/property'
import FacilityCategory from '../../Facilities/Category'

import styles from './styles.module.css'
import { Facility } from '../Facility'
import { FacilityCategories } from 'client/components/Facilities/Categories'

const SHOWN_FACILITIES_LIMIT = 6

interface IFacilitiesListProps {
  facilities: PropertyFacilities[]
  categories: FacilityCategories[]
  hideTitleIcon?: boolean
  showFreeTag?: boolean
}

export function FacilitiesList({
  facilities,
  categories,
  hideTitleIcon = false,
  showFreeTag = false,
}: Readonly<IFacilitiesListProps>) {
  if (!facilities.length || !categories.length) {
    return null
  }

  const limitFacilitiesShown = (category: number | null) => {
    return !category
  }

  return (
    <div className={styles.facilitiesList} data-testid="facilities-list">
      {categories.map(category => (
        <div key={category} className={styles.facilityCategory} data-testid="facility-category">
          {category && <FacilityCategory code={category} hideIcon={hideTitleIcon} />}
          <ul className={styles.facilityList}>
            {facilities
              .filter(facility => facility.categoryCode === category)
              .slice(0, limitFacilitiesShown(category) ? SHOWN_FACILITIES_LIMIT : undefined)
              .map(facility => (
                <li
                  key={`${facility.name}-facility`}
                  className={styles.facility}
                  data-testid="facility"
                >
                  <Facility
                    icon={facility.icon}
                    name={facility.name}
                    freeTag={showFreeTag && facility.free}
                  />
                </li>
              ))}
          </ul>
        </div>
      ))}
    </div>
  )
}
